import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout for all routes nested under $pinId (e.g. task/create-task).
// PlanViewerNew renders the pin independently via useParams({ strict: false }).
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId'
)({
  component: () => <Outlet />
})
